export const formatSignUpRequest = (values) => {
  const {
    firstName, lastName, email, password, phone, companyCode, company,
  } = values;
  const name = `${firstName} ${lastName}`;

  return {
    username: email,
    password,
    attributes: {
      name,
      email,
      'custom:companyCode': companyCode || '',
      'custom:company': company || `${name}'s Company`,
      'custom:isIndividual': '0',
      'custom:defaultCountry': 'SA',
    },
    validationData: [], // optional
  };
};

export const getPostData = (values) => {
  const {
    firstName, lastName, email, phone,
  } = values;
  return {
    email,
    phone,
    firstName,
    lastName,
    defaultCountry: 'SA',
    address: 'My address',
  };
};

export const getAccountData = (values) => {
  const { phone, companyCode, company } = values;

  return {
    address: 'Address',
    bankName: 'Bank Name',
    iban: 'iBanNumber',
    name: company || `${name}'s Company`,
    companyCode,
    phone,
    defaultCountry: 'SA',
    domain: SYSTEM_DOMAIN,
  };
};
